import { StringService } from "./string.service";

export { HttpService } from "./http.service";
export { DateService } from "./date.service";
export { UIService } from "./ui.service";
export { StringService } from "./string.service";
export { RouteService } from "./route.service";
export { ValidationService } from "./validation.service";
export { BrowserService } from "./browser.service";
export * from "./player.service";
export { DevService } from "./dev.service";
export { SeoService } from "./seo.service";

export const _ = StringService.Lang;